const DraftCartDropdown: React.FC = () => (
  <div className="min-h-40" data-testid="draft-cart-dropdown" />
);

export default DraftCartDropdown;
